import { useState } from 'react';
import supabase from '../lib/supabase';

export default function AuthScreen() {
  const [tab, setTab] = useState('login'); // login | signup | reset
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [checkEmail, setCheckEmail] = useState(false);
  const [resetSent, setResetSent] = useState(false);

  async function handleGoogle() {
    await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: window.location.origin },
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError(null);

    if (tab === 'login') {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) setError(error.message);
    } else if (tab === 'signup') {
      const { error } = await supabase.auth.signUp({ email, password });
      if (error) setError(error.message);
      else setCheckEmail(true);
    } else if (tab === 'reset') {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: 'https://gedreadyprep.com',
      });
      if (error) setError(error.message);
      else setResetSent(true);
    }
    setLoading(false);
  }

  // ── Check email screen shown after signup ──
  if (checkEmail) {
    return (
      <div className="auth-screen">
        <div className="auth-card auth-check-email">
          <div className="auth-check-icon">📬</div>
          <h2 className="auth-check-title">Check your email</h2>
          <p className="auth-check-desc">
            We sent a confirmation link to <strong>{email}</strong>.
            Click it to activate your account, then come back and log in.
          </p>
          <button
            className="primary-btn auth-submit"
            style={{ background: 'linear-gradient(135deg,#6366f1,#8b5cf6)' }}
            onClick={() => { setCheckEmail(false); setTab('login'); }}
          >
            Back to Log In
          </button>
        </div>
      </div>
    );
  }

  if (resetSent) {
    return (
      <div className="auth-screen">
        <div className="auth-card auth-check-email">
          <div className="auth-check-icon">📩</div>
          <h2 className="auth-check-title">Check your email</h2>
          <p className="auth-check-desc">
            We sent a password reset link to <strong>{email}</strong>.
          </p>
          <button
            className="primary-btn auth-submit"
            style={{ background: 'linear-gradient(135deg,#6366f1,#8b5cf6)' }}
            onClick={() => { setResetSent(false); setTab('login'); }}
          >
            Back to Log In
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-screen">
      <div className="auth-card">
        <div className="auth-logo">
          <span className="sidebar-logo">GED</span>
          <span className="sidebar-logo-sub">Ready Prep</span>
        </div>
        <p className="auth-tagline">AI-powered GED exam prep</p>

        <div className="auth-tabs">
          <button
            className={`auth-tab ${tab === 'login' ? 'auth-tab--active' : ''}`}
            onClick={() => { setTab('login'); setError(null); }}
          >
            Log In
          </button>
          <button
            className={`auth-tab ${tab === 'signup' ? 'auth-tab--active' : ''}`}
            onClick={() => { setTab('signup'); setError(null); }}
          >
            Sign Up
          </button>
        </div>

        <button type="button" className="google-btn" onClick={handleGoogle}>
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" width="18" height="18" />
          Continue with Google
        </button>
        <div className="auth-divider"><span>or</span></div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <input
            className="auth-input"
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          {tab !== 'reset' && (
            <input
              className="auth-input"
              type="password"
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              minLength={6}
            />
          )}

          {error && <p className="auth-error">{error}</p>}

          <button
            className="primary-btn auth-submit"
            style={{ background: 'linear-gradient(135deg,#6366f1,#8b5cf6)' }}
            disabled={loading}
          >
            {loading ? 'Please wait…' :
             tab === 'login' ? 'Log In' :
             tab === 'reset' ? 'Send Reset Link' : 'Create Account'}
          </button>

          {tab === 'login' && (
            <button
              type="button"
              className="auth-forgot"
              onClick={() => { setTab('reset'); setError(null); }}
            >
              Forgot password?
            </button>
          )}
          {tab === 'reset' && (
            <button
              type="button"
              className="auth-forgot"
              onClick={() => { setTab('login'); setError(null); }}
            >
              Back to Log In
            </button>
          )}
        </form>
      </div>
    </div>
  );
}
